import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./index.less"

export default createReactClass({
  displayName: "TabContent",
  propTypes: {
    className: PropTypes.string,
    isActive: PropTypes.bool,
  },
  render() {
    let className = classnames({
      [styles.hide]: !this.props.isActive,
    })

    return <div className={className}>{this.props.children}</div>
  },
})
